import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link } from "react-router-dom";
import firebase from "firebase/app";
import JI from '../../assets/logo/ji.png'
import './Header.css'
import { toast } from 'react-toastify';
import { instituteCheck } from '../../api/institute';

const Header = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => ({ ...state }));

    const handleLogout = () => {
        firebase.auth().signOut();
        dispatch({
            type: "LOGOUT",
            payload: null,
        });
        history.push("/login");
    };

    const handleClick = e => {
        e.preventDefault();
        if (user && user.token) {
            instituteCheck(user._id, user.token)
                .then(res => {
                    if (res.data.institute)
                        history.push(`/admin/dashboard`)
                    else
                        history.push(`/add-my-institute`)
                })
                .catch(err => {
                    toast.error(err.response ? err.response.data : 'There some error please try again later')
                })
        } else {
            toast.error('Please login first')
            history.push(`/login`)
        }
    }

    const HomeIcon = () => (
        <img id='home-logo' style={{ width: '1.7rem' }} src={JI} alt="J.I" />
    )


    return (<nav id='header' className="navbar navbar-expand-md bg-light navbar-light">
        <div className="container">
            <ul className="navbar-nav">
                <li className="nav-item">
                    <Link to='/' className="nav-link"><span className='navbar-brand'>{HomeIcon()}</span></Link>
                </li>
            </ul>

            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navmenu"
            >
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navmenu">
                <ul className="navbar-nav ms-auto">
                    {
                        user ? (
                            <div class="nav-item btn-group">
                                <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    {user.name}
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><Link to='/user/dashboard' className="nav-link">My WorkSpace</Link></li>
                                    <li><Link to='/' onClick={handleClick} className="nav-link">My Institute</Link></li>
                                    <li><Link to='/' onClick={e => { e.preventDefault(); handleLogout() }} className="nav-link">Logout</Link></li>
                                </ul>
                            </div>
                        ) : (<>
                            <li className="nav-item">
                                <Link to='/login' className="nav-link">Login</Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/register' className="nav-link">Register</Link>
                            </li>
                        </>)
                    }
                </ul>
            </div>
        </div>
    </nav>)
};

export default Header;